import { number, shape, bool } from "prop-types";
import { testDriveLocationType } from "@types";

export const propTypes = {
  pageProps: shape({
    errorStatusCode: number,
    testDriveLocation: testDriveLocationType,
  }),
  isSSRRendered: bool,
};
